import { useAppSelector } from '../../../hooks';
import { getTodo, getTodoList } from './TodoSlice';
import { Navigate, useNavigate } from 'react-router-dom';
import TodoTabs from './TodoTabs';
import { Card, CardBody, CardHeader, Spinner } from 'reactstrap';

const TodoCard = () => {
    const todo = useAppSelector(getTodoList);
    const loading = useAppSelector((state) => state.todo.loading);
    const navigate = useNavigate();

    return (
        <Card style={{ maxHeight: '50vh', minHeight: '50vh' }}>
            <CardHeader
                onClick={() => navigate('/TodoList')}
                style={{ cursor: 'pointer' }}
                className='bg-white'
            >
                <span className='headerText'>To-Do List</span>
            </CardHeader>
            <div style={{ overflowY: 'auto', paddingInline: 10 }}>
                {loading || todo?.length === 0 ? (
                    <div style={{ flex: 1, justifyContent: 'center' }}>
                        <Spinner 
                            color="primary"
                            style={{ width: '3rem', height: '3rem'}}
                        />
                    </div>
                )
                : (
                    <div>
                        <TodoTabs 
                            todo={todo}
                            sticky={true}
                            stickyTop={0}
                        />
                    </div>
                )}
            </div>
        </Card>
    );
};

export default TodoCard;